import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './WizardCategories.css';
import React, { useContext, useState, useMemo, useEffect, useRef } from 'react';
import throttle from 'lodash/throttle';
/* import { useLocation, useHistory } from 'react-router-dom'; */

import clsx from 'clsx';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import LazyPicture from '../atoms/LazyPicture';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import CategoryDetails from './CategoryDetails';
import { canUseDOM, getColorByTheme, getPageThemeColors, get, injectImageResolution, getDictionaryItem } from '../../utils';
import { ReactComponent as ChevronDownIcon } from '../../resources/icons/chevron-down-big.svg';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { checkJssError } from '../../utils/checkJssError';
;
var WizardCategories = function WizardCategories(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var detailsWrapper = useRef(null);
  var _useState = useState('0px'),
    _useState2 = _slicedToArray(_useState, 2),
    desktopDetailsWrapperHeight = _useState2[0],
    setDesktopDetailsWrapperHeight = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    additionalOpenRecountFlag = _useState4[0],
    setAdditionalOpenRecountFlag = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isVdsite = _useState6[0],
    setIsVdsite = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    expandedIds = _useState8[0],
    setExpandedIds = _useState8[1];
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  /* const pageEditing: boolean = Boolean(sitecoreContext && sitecoreContext.pageEditing); */
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var title = get(fields, 'data.item.title.jss.value');
  var shortDescription = get(fields, 'data.item.shortDescription.jss.value');
  var cards = get(fields, 'data.item.categories.items', []);

  /* Dictionaries vals*/
  var dictionary = get(fields, 'data.dictionary');
  var backToTopTerm = getDictionaryItem(dictionary, 'backToTop') || '';
  var showCarousel = useMemo(function () {
    return cards.length > 5;
  }, [cards]);
  var actualSSR = process.env.STORYBOOK_MODE ? false : sitecoreContext.route && sitecoreContext.route.fromSSR;
  var isMobile = useMemo(function () {
    return !actualSSR && canUseDOM && window.matchMedia("(max-width: 991px)").matches;
  }, [actualSSR]);
  var detailsAsAccordeon = useMemo(function () {
    return isMobile && !showCarousel;
  }, [isMobile, showCarousel]);

  /* Theme setttings */
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var variables = BackgroundColorHex ? {
    '--m134-category-wizard-background-color': BackgroundColorHex,
    '--m134-category-wizard-background-active-color': ActiveColorHex,
    '--m134-category-wizard-color': ColorHex
  } : {
    '--m134-category-wizard-background-color': primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    '--m134-category-wizard-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m134-category-wizard-color': getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  /* End Theme setttings */

  var countHeight;
  if (canUseDOM) {
    countHeight = throttle(function () {
      if (detailsWrapper.current) {
        var visibleDetailsBlock = detailsWrapper.current.querySelector('.js--details-visible');
        if (visibleDetailsBlock) {
          setDesktopDetailsWrapperHeight(getComputedStyle(visibleDetailsBlock).getPropertyValue('--wc-details-height'));
        }
      }
    }, 300);
  }
  useEffect(function () {
    if (canUseDOM) {
      window.addEventListener('resize', countHeight);
    }
    return function () {
      window.removeEventListener('resize', countHeight);
    };
  }, []);
  useEffect(function () {
    setTimeout(countHeight, 300);
  }, [sitecoreContext.selectedFontSize]);
  useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  useEffect(function () {
    if (canUseDOM && (showCarousel || !isMobile) && detailsWrapper.current) {
      if (expandedIds.length) {
        var visibleDetailsBlock = detailsWrapper.current.querySelector('.js--details-visible');
        setDesktopDetailsWrapperHeight(getComputedStyle(visibleDetailsBlock).getPropertyValue('--wc-details-height'));
      } else {
        setDesktopDetailsWrapperHeight('0px');
      }
    }
  }, [expandedIds, isMobile]);
  useEffect(function () {
    if (additionalOpenRecountFlag && canUseDOM) {
      setTimeout(countHeight, 100);
    }
  }, [additionalOpenRecountFlag]);

  /* const loadMore = (): void => {}; */

  var categoryClickHandlerAccordeon = function categoryClickHandlerAccordeon(categoryId) {
    return function () {
      scroolToElement(categoryId);
      if (!additionalOpenRecountFlag) {
        setAdditionalOpenRecountFlag(true);
      }
      if (expandedIds.includes(categoryId)) {
        setExpandedIds(expandedIds.filter(function (id) {
          return id !== categoryId;
        }));
      } else {
        setExpandedIds([categoryId].concat(_toConsumableArray(expandedIds)));
      }
    };
  };
  var categoryClickHandler = function categoryClickHandler(categoryId) {
    return function () {
      scroolToElement(categoryId);
      if (!additionalOpenRecountFlag) {
        setAdditionalOpenRecountFlag(true);
      }
      setExpandedIds(expandedIds[0] === categoryId ? [] : [categoryId]);
    };
  };
  var backToTopClickHandler = function backToTopClickHandler(e) {
    var carousel = e.target.closest('.wc-container-wrapper--in-carousel');
    var stickyNav = document.querySelector(isVdsite ? '.main-nav' : '.dot-site-header--fixed');
    var navHeight = stickyNav ? stickyNav.offsetHeight : 0;
    if (carousel) {
      setExpandedIds([]);
      window.scrollTo(0, carousel.getBoundingClientRect().top + window.scrollY - navHeight);
    }
  };
  var wizardWrapperRef = useRef(null);
  var scroolToElement = function scroolToElement(id) {
    if (wizardWrapperRef.current) {
      window.scrollTo({
        top: window.scrollY + wizardWrapperRef.current.querySelector(".wc__list-item--".concat(id)).getBoundingClientRect().top,
        behavior: 'smooth'
      });
    }
  };
  var renderItems = function renderItems(state) {
    var startItemToShow = state ? state.currentSlide : null;
    var endItemToShow = state ? state.currentSlide + state.slidesToShow - 1 : null;
    return cards.filter(function (card) {
      return get(card, 'title.jss.value') && get(card, 'title.jss.value') !== '$name';
    }).map(function (card, index) {
      var title = get(card, 'title.jss.value');
      var highlightTitle = get(card, 'highlightTitle.jss.value');
      var highlightSubTitle = get(card, 'highlightSubtitle.jss.value');
      var image = get(card, 'image.jss.value');
      var itemVisible = !state || typeof startItemToShow === 'number' && typeof endItemToShow === 'number' && index >= startItemToShow && index <= endItemToShow;
      return /*#__PURE__*/React.createElement("div", {
        className: "wc__list-item wc__list-item--".concat(card.id),
        key: card.id
      }, /*#__PURE__*/React.createElement("div", {
        className: clsx('wc__card', {
          'wc__card--expanded': expandedIds.includes(card.id)
        })
      }, /*#__PURE__*/React.createElement("div", {
        tabIndex: itemVisible ? 0 : -1,
        className: "wc__card-frame",
        onClick: detailsAsAccordeon ? categoryClickHandlerAccordeon(card.id) : categoryClickHandler(card.id),
        onKeyPress: function onKeyPress(event) {
          if (event.key === 'Enter' || event.key === 'NumpadEnter' || event.which === 32) {
            event.preventDefault();
            if (detailsAsAccordeon) {
              categoryClickHandlerAccordeon(card.id)();
            } else {
              categoryClickHandler(card.id)();
            }
          }
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "wc__card__analytics-trigger",
        onClick: function onClick() {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['bannerClickAnalytics'], params), title);
        }
      }, /*#__PURE__*/React.createElement(LazyPicture, {
        hover: true,
        useEmptyPlaceholder: true
      }, /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 1441px)",
        srcSet: injectImageResolution(image.src, 1420, 800)
      }), /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 992px)",
        srcSet: injectImageResolution(image.src, 1096, 800)
      }), /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 568px)",
        srcSet: injectImageResolution(image.src, 1850, 400)
      }), /*#__PURE__*/React.createElement("img", {
        className: "wc__card-image",
        src: injectImageResolution(image.src, 1040, 400),
        alt: image.alt
      }))), /*#__PURE__*/React.createElement("h4", {
        className: "wc__card__title"
      }, title), /*#__PURE__*/React.createElement("div", {
        className: "wc__card__highlight",
        onClick: function onClick() {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['titleClickAnalytics'], params), "".concat(highlightTitle));
        }
      }, highlightTitle && /*#__PURE__*/React.createElement("h6", {
        className: "wc__card__highlight-title"
      }, highlightTitle), highlightSubTitle && /*#__PURE__*/React.createElement("p", {
        className: "wc__card__highlight-subtitle"
      }, /*#__PURE__*/React.createElement("strong", null, highlightSubTitle))), /*#__PURE__*/React.createElement("span", {
        className: "wc__card__opener",
        onClick: function onClick() {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['titleClickAnalytics'], params), "".concat(highlightTitle));
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "wc__card__opener-disc"
      }), /*#__PURE__*/React.createElement(ChevronDownIcon, {
        className: "icon"
      })))), !showCarousel && isMobile && /*#__PURE__*/React.createElement(CategoryDetails, {
        cardsToShow: expandedIds,
        cardsProps: card,
        rtl: rtl,
        toTopTerm: backToTopTerm,
        additionalRecount: additionalOpenRecountFlag,
        isMobile: isMobile,
        analytics: {
          eventsAnalytics: eventsAnalytics,
          params: params
        }
      }));
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter'],
    cssVars: variables,
    isCarousel: showCarousel,
    isMobile: isMobile
  }, /*#__PURE__*/React.createElement("div", {
    ref: wizardWrapperRef
  }, /*#__PURE__*/React.createElement("h2", {
    className: "h3 wc__title"
  }, title), (isMobile || !showCarousel) && /*#__PURE__*/React.createElement("h5", {
    className: "wc__short-description"
  }, shortDescription), !showCarousel && isMobile && /*#__PURE__*/React.createElement("div", {
    className: "wc__list-wrapper"
  }, renderItems()), !showCarousel && !isMobile && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "wc__list-wrapper row"
  }, renderItems())), showCarousel && /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref2) {
    var renderCarousel = _ref2.renderCarousel,
      renderPreviousButton = _ref2.renderPreviousButton,
      renderNextButton = _ref2.renderNextButton,
      renderDots = _ref2.renderDots,
      state = _ref2.state;
    return /*#__PURE__*/React.createElement(React.Fragment, null, !isMobile && /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-start justify-content-between"
    }, /*#__PURE__*/React.createElement("h5", {
      className: "wc__short-description"
    }, shortDescription), /*#__PURE__*/React.createElement("div", {
      className: "wc__carousel-controls"
    }, renderPreviousButton(function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['prevNavAnalytics'], params));
    }, true, false), renderNextButton(function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['nextNavAnalytics'], params));
    }, true, false))), renderCarousel(renderItems(state), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 992
          },
          items: 5
        },
        mobile: {
          breakpoint: {
            max: 991,
            min: 0
          },
          items: 1
        }
      },
      beforeChange: function beforeChange() {
        setExpandedIds([]);
      }
    }), renderDots(function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navBubblesAnalytics'], params));
    }));
  }), (showCarousel || !isMobile) && /*#__PURE__*/React.createElement("div", {
    className: clsx("wc__details-wrapper-visibility", {
      "wc__details-wrapper-visibility--visible": expandedIds[0]
    }),
    style: {
      '--details-wrapper-height': desktopDetailsWrapperHeight
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "wc__details-wrapper-border"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wc__details-wrapper",
    ref: detailsWrapper
  }, cards.filter(function (card) {
    return get(card, 'title.jss.value') && get(card, 'title.jss.value') !== '$name';
  }).map(function (card) {
    return /*#__PURE__*/React.createElement(CategoryDetails, {
      key: card.id,
      cardsToShow: expandedIds,
      cardsProps: card,
      rtl: rtl,
      toTopTerm: backToTopTerm,
      additionalRecount: additionalOpenRecountFlag,
      isMobile: isMobile,
      inCarousel: showCarousel,
      backToTopHandler: backToTopClickHandler,
      analytics: {
        eventsAnalytics: eventsAnalytics,
        params: params
      }
    });
  }))))));
};
var ValidatedComponent = function ValidatedComponent(props) {
  return checkJssError(props, WizardCategories);
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl,
    anchorUrlParameter = _ref3.anchorUrlParameter,
    cssVars = _ref3.cssVars,
    isCarousel = _ref3.isCarousel,
    isMobile = _ref3.isMobile;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx({
      'wc-container-wrapper--in-carousel': isCarousel,
      'wc-container-wrapper--desktop': !isMobile
    })
  }, /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: clsx(commonStyles, rtl ? rtlStyles : ltrStyles),
    style: cssVars
  }, children));
};
var commonStyles = "ciop7t8";
var ltrStyles = "l1tryd9v";
var rtlStyles = "r8zz39z";
export default ValidatedComponent;